import { MarketPaths } from "Market/Routes/Routing";
import { getMarketFromPath } from "Market/Utilities/getMarketFromPath";
import Session from "supertokens-auth-react/recipe/session";
import ThirdParty, {
	GoogleWorkspaces,
} from "supertokens-auth-react/recipe/thirdparty";

export const getSupertokensInit = () => {
	const marketPath = getMarketFromPath();

	return {
		enableDebugLogs: false,
		appInfo: {
			appName: import.meta.env.VITE_APP_NAME,
			websiteDomain: import.meta.env.VITE_WEBSITE_DOMAIN,
			apiDomain: import.meta.env.VITE_API_DOMAIN,
			apiBasePath: import.meta.env.VITE_API_BASE_PATH,
			websiteBasePath: import.meta.env.VITE_WEBSITE_BASE_PATH,
		},
		getRedirectionURL: async (context) => {
			if (context.action === "SUCCESS" && context.newSessionCreated) {
				if (
					context.redirectToPath !== undefined &&
					context.redirectToPath !== ""
				) {
					if (context.redirectToPath.startsWith(`/${marketPath}`)) {
						return context.redirectToPath.slice(marketPath.length + 1); // +1 to remove the leading slash
					}

					return context.redirectToPath;
				}
				return MarketPaths.Select.path;
			}

			if (context.action === "SUCCESS" && !context.newSessionCreated) {
				return MarketPaths.Select.path;
			}

			return undefined;
		},
		recipeList: [
			ThirdParty.init({
				signInAndUpFeature: {
					providers: [
						GoogleWorkspaces.init({
							name: "Google",
						}),
					],
				},
			}),
			Session.init(),
		],
		style: `
            [data-supertokens~=authPage] [data-supertokens~=headerSubtitle] {
                display: none;
            }
        `,
	};
};
